(function (angular) {
    'use strict';

    angular.module('branch')

        /**
         *
         */
        .factory('rulesService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;

                    var fac = {
                        getRules: getRules,
                        getRule: getRule,
                        createRule: createRule,
                        updateRule: updateRule,
                        deleteRule: deleteRule
                    };

                    return fac;


                    /**
                     * GET "/apispaces/{id}/rules"
                     * @param {string} id - the api space Id
                     */
                    function getRules(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/rules/sets")
                            .then(getRulesComplete)
                            .catch(getRulesFailed);

                        function getRulesComplete(response) {
                            return response.data;
                        }

                        function getRulesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispaces/{id}/rules/{ruleId}"
                     * @param {string} id - the api space Id
                     * @param {string} ruleId - the rule id
                     */
                    function getRule(id, ruleId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/rules/sets/" + encodeURIComponent(ruleId))
                            .then(getRuleComplete)
                            .catch(getRuleFailed);

                        function getRuleComplete(response) {
                            return response.data;
                        }

                        function getRuleFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * POST "/apispaces/{id}/rules"
                     * @param {string} id - the api space Id
                     * @param {object} data - the rule data
                     */
                    function createRule(id, data) {

                        return $http.post(urlBase + "/apispaces/" + id + "/rules/sets", data)
                            .then(getRuleComplete)
                            .catch(getRuleFailed);

                        function getRuleComplete(response) {
                            return response.data;
                        }

                        function getRuleFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * PUT "/apispaces/{id}/rules"
                     * @param {string} id - the api space Id
                     * @param {object} data - the rule data
                     */
                    function updateRule(id, data) {

                        return $http.put(urlBase + "/apispaces/" + id + "/rules/sets/" + encodeURIComponent(data.id), data)
                            .then(updateRuleComplete)
                            .catch(updateRuleFailed);

                        function updateRuleComplete(response) {
                            return response.data;
                        }

                        function updateRuleFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * DELETE "/apispaces/{id}/rules"
                     * @param {string} id - the api space Id
                     * @param {string} ruleId - the rule id
                     */
                    function deleteRule(id, ruleId) {


                        return $http.delete(urlBase + "/apispaces/" + id + "/rules/sets/" + encodeURIComponent(ruleId))
                            .then(deleteRuleComplete)
                            .catch(deleteRuleFailed);

                        function deleteRuleComplete(response) {
                            return response.data;
                        }

                        function deleteRuleFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);

})(window.angular);
